var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.navigationData.pageTitle)?_c('PageHeader',{attrs:{"id":"pageTitle","pageTitle":_vm.pageTitle,"isChanging":_vm.isChanging}}):_vm._e(),_c('div',{staticClass:"container content-container"},[_c('transition',{attrs:{"mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1),_c('CheckoutBox')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }